(function() {
	let contactButtonLink = document.querySelector(".mobile-cta a");
	if(!contactButtonLink) {
		return;
	}

	let ctaLink = document.querySelector(".cta a");
	if(!ctaLink) {
		return;
	}

	contactButtonLink.search += ctaLink.search;
})();
